import { CONTRACT_INFO } from "config"
import { ArtBlocksChainId, arbTestnetContractConfig, mainnetContractConfig, testnetContractConfig } from "contractConfig"
import { isArtBlocksChainId } from "utils/artBlocksUrls"

const ALL_CONTRACT_INFO = [
    ...CONTRACT_INFO,
    ...mainnetContractConfig,
    ...testnetContractConfig,
    ...arbTestnetContractConfig,
]

export const getContractConfigByAddress = (contractAddress: string) => {
   return ALL_CONTRACT_INFO.find(
        x => x.CORE_CONTRACT_ADDRESS.toLowerCase() === contractAddress.toLowerCase()
    )
}

export const getContractChainId = (contractAddress: string, chainId?: number | string | null): ArtBlocksChainId | undefined => {
    if (isArtBlocksChainId(chainId)) return Number(chainId) as ArtBlocksChainId

    const contractConfig = getContractConfigByAddress(contractAddress)
    if (isArtBlocksChainId(contractConfig?.CHAIN_ID)) return contractConfig?.CHAIN_ID

    return undefined
}

export const getConfiguredContractAddresses = () => {
    return CONTRACT_INFO.map(x => x.CORE_CONTRACT_ADDRESS)
}
